export default __webpack_public_path__ + "static/media/rupee.ec255058.jpg";